import moment from 'moment';

( moment as any ).fn.getDay = function ( this: moment.Moment ): number {
    return this.format( 'D' ).toInt();
};

( moment as any ).fn.getMonth = function ( this: moment.Moment ): number {
    return this.format( 'M' ).toInt();
};

( moment as any ).fn.getYear = function ( this: moment.Moment ): number {
    return this.format( 'YYYY' ).toInt();
};

( moment as any ).fn.compare = function ( this: moment.Moment, hoy: moment.Moment ): boolean {
    return hoy.getDay() === this.getDay() && hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
};

( moment as any ).fn.toSQL = function ( this: moment.Moment, hora: boolean = true ): string | null {
    if ( !this.isValid() ) return null;
    return this.format( 'YYYY-MM-DD' ) + ( hora ? ' ' + this.format( 'HH:mm:ss' ) : '' );
};

( moment as any ).fn.isYesterday = function ( this: moment.Moment ): boolean {
    let ayer = moment().add( -1, 'days' );
    return this.compare( ayer );
};

( moment as any ).fn.isToday = function ( this: moment.Moment ): boolean {
    let hoy = moment();
    return hoy.getDay() === this.getDay() && hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
};

( moment as any ).fn.mismoMes = function ( this: moment.Moment ): boolean {
    let hoy = moment();
    return hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear();
};




( moment as any ).fn.toMensaje = function ( this: moment.Moment ): string {
    if ( !this.isValid() ) return '';
    let hoy = moment();
    if ( hoy.isAfter( this ) ) {

        if ( this.isToday() ) {
            return this.fromNow();
        }
        else if ( this.isYesterday() ) {
            return 'ayer';
        }
        else {
            return this.format( 'DD/MM/YY' );
        }

        //else if ( hoy.getMonth() === this.getMonth() && hoy.getYear() === this.getYear() ) {
        //    return this.format( 'dddd D' );
        //}
        //else if ( hoy.getYear() === this.getYear() ) {
        //    return this.format( 'D' ) + " de " + this.format( 'MMMM' );
        //} else {
        //    return this.format( 'D' ) + " de " + this.format( 'MMMM YYYY' );
        //}

    } else {
        return this.format( 'DD/MM/YY' );
        //return this.format( 'D' ) + " de " + this.format( 'MMMM YYYY' );
    }

};

( moment as any ).fn.toFecha = function ( this: moment.Moment, hora: boolean = false, dia: boolean = true ): string {

    if ( !this.isValid() ) return '';
    return ( dia ? this.format( 'dddd, ' ) : '' ) + this.format( 'D' ) + " de " + this.format( 'MMMM' ) + ' de ' + this.format( 'YYYY' ) + ( hora ? ' ' + this.toHora() : '' );
};

( moment as any ).fn.toHora = function ( this: moment.Moment ): string {
    if ( !this.isValid() ) return '';
    return this.format( 'HH:mm' );
};

( moment as any ).fn.toFechaMensaje = function ( this: moment.Moment ): string {

    if ( !this.isValid() ) return '';
    if ( this.isToday() )
        return this.format( 'HH:mm' );
    else if ( this.isAfter( moment().add( -3, 'days' ) ) )
        return this.format( 'dddd' ) + ' ' + this.format( 'HH:mm' );
    return this.format( 'DD/MM/YY' ) + ' ' + this.format( 'HH:mm' );
};

( moment as any ).fn.toFechaChat = function ( this: moment.Moment ): string {

    if ( !this.isValid() ) return '';
    if ( this.isToday() )
        return this.format( 'HH:mm' );
    else if ( this.isAfter( moment().add( -3,'days'  ) ) )
        return this.format( 'dddd' );
    return this.format( 'DD/MM/YY' );
};

( moment as any ).fn.toDay = function ( this: moment.Moment ): string {

    if ( !this.isValid() ) return '';
    if ( this.isToday() ) return 'HOY';
    else if ( this.isYesterday() ) return 'AYER';
    else if ( this.isAfter( moment().add( -4, 'days') ) )
        return this.format( 'dddd' );

    return this.format( 'DD/MM/YY' );
};


